import {useDisclosure} from '@mantine/hooks';
import {createContext, useContext, useRef} from 'react';
import type React from 'react';

type GuideModalContextType = {
  opened: boolean;
  open: () => void;
  close: () => void;
  onAddEntryRef: React.MutableRefObject<(() => void) | undefined>;
};

const GuideModalContext = createContext<GuideModalContextType | undefined>(
  undefined,
);

export const useGuideModal = () => {
  const context = useContext(GuideModalContext);
  if (context === undefined) {
    throw new Error('useGuideModal must be used within GuideModalProvider');
  }
  return context;
};

type GuideModalProviderProps = {
  children: React.ReactNode;
};

export const GuideModalProvider: React.FC<GuideModalProviderProps> = ({
  children,
}) => {
  const [opened, {open, close}] = useDisclosure(false);
  const onAddEntryRef = useRef<(() => void) | undefined>(undefined);

  return (
    <GuideModalContext.Provider value={{opened, open, close, onAddEntryRef}}>
      {children}
    </GuideModalContext.Provider>
  );
};
